module.exports = __webpack_public_path__ + "static/media/42_tn.c8beeba8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/42_tn.jpg
// module id = 530
// module chunks = 0